<template>
  <div 
    class=" ">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Terima kasih, password Anda
                </div>

                <div>
                  telah berhasil diubah!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-card
            flat
            :min-height="`calc(100vh - 220px)`"
            class="box-shadow mb-3"
            style="overflow-y: auto;">
            <v-card-text
              class="pt-8">
              <!-- <div class="fs-17 font-weight-medium" style="color: #333B69;">
                Two-factor Authentication
              </div>

              <div>
                <v-switch
                  v-model="form.authentication"
                  inset
                  color="#16DBCC"
                >
                <template v-slot:label>
                  <div class="fs-16 label-input">
                    Enable or disable two factor authentication
                  </div>
                </template>
                </v-switch>
              </div> -->
              <div class="fs-17 font-weight-medium" style="color: #333B69;">
                Change Password
              </div>
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col
                      cols="6">
                      <ValidationProvider 
                        name="Current Password" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-15 mb-1">
                          <span class="red--text">*</span>

                          Current Password
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          outlined
                          rounded
                          dense
                          
                          :color="set_color"
                          placeholder="Contoh. ******"
                          :type="show.old_password ? 'text' : 'password'"
                          :append-icon="show.old_password ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="show.old_password = !show.old_password"
                          :counter="30"

                          v-model="form.old_password"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>

                      <ValidationProvider 
                        name="New Password" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-15 mb-1">
                          <span class="red--text">*</span>
  
                          New Password
                        </div>
  
                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          outlined
                          rounded
                          dense
                          
                          :color="set_color"
                          placeholder="Contoh. ******"
                          :type="show.new_password ? 'text' : 'password'"
                          :append-icon="show.new_password ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="show.new_password = !show.new_password"
                          :counter="30"
  
                          v-model="form.new_password"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>

                  </v-row>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center my-4 d-flex align-center">
                <div
                  class="error--text">
                  <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <div class="text-right pt-5">
            <v-btn 
              @click="save()"
              :loading="process.form"
              :disabled="process.form"
              color="#4B4B4B"
              elevation="0"
              class="body-2 white--text text-capitalize ml-3"
              style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
              <v-icon
                size="20">
                mdi-checkbox-marked-circle-outline
              </v-icon>

              <span
                class="ml-2">
                Simpan
              </span>
            </v-btn>
          </div>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          success: false
        },

        show: {
          old_password: false,
          new_password: false
        },

        form: {
          old_password: '',
          new_password: '',
          // authentication: true
        },

        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`account/update-password`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              if (this.$refs.form) this.$refs.form.reset()

              this.form = {
                old_password: '',
                new_password: '',
                // authentication: true
              }
              
              this.dialog.success = true
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>